export default class ClearFormInputs {

    constructor() {
        this.settings = {
            $clearForm : $(".js-clear-form-inputs")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$clearForm.length) {
            const clearForm = document.querySelector('.js-clear-form-inputs');

            clearForm.addEventListener('click', () => {

                // Reset select inputs
                document.getElementById('grant-category').value = '';

                // Submit the form
                document.getElementById('grants').submit();

            }); 
        }
    }
};

new ClearFormInputs();